/**
 * HubSpot API client (frontend).
 */

import { supabase } from './supabase';

const API_URL =
  import.meta.env.VITE_API_URL ??
  (typeof window !== 'undefined' && window.location.hostname === 'localhost'
    ? 'http://localhost:8787'
    : 'https://api.waypoint-intel.com');

async function authHeader(): Promise<Record<string, string>> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');
  return { Authorization: `Bearer ${session.access_token}` };
}

export async function getHubSpotAuthUrl(returnTo: string): Promise<string> {
  const headers = await authHeader();
  const qs = new URLSearchParams({ returnTo });
  const res = await fetch(`${API_URL}/v1/integrations/hubspot/connect?${qs}`, { headers });
  if (!res.ok) {
    const body = await res.json().catch(() => ({})) as { error?: string; hint?: string };
    throw new Error(body.hint || body.error || `API ${res.status}`);
  }
  const data = (await res.json()) as { authUrl: string };
  return data.authUrl;
}

export async function disconnectHubSpot(): Promise<void> {
  const headers = await authHeader();
  const res = await fetch(`${API_URL}/v1/integrations/hubspot`, { method: 'DELETE', headers });
  if (!res.ok) throw new Error(`API ${res.status}`);
}

export async function syncHubSpotNow(): Promise<{
  contactsUpserted: number;
  dealsUpserted: number;
  signalsCreated: number;
}> {
  const headers = await authHeader();
  const res = await fetch(`${API_URL}/v1/integrations/hubspot/sync`, { method: 'POST', headers });
  if (!res.ok) {
    const body = await res.json().catch(() => ({})) as { error?: string; detail?: string };
    throw new Error(body.detail || body.error || `API ${res.status}`);
  }
  return (await res.json()) as { contactsUpserted: number; dealsUpserted: number; signalsCreated: number };
}
